// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getSelectAllText} from '../../shared/services/criteria';

const BasicWarrantyEstimatorDealerCriteria = props => {

    const dealerSelectionMessage = getSelectAllText(props.selectedDealers);

    return (
        <section className='basic-warranty-estimator-dealer-criteria'>
            <CheckboxListWithLabel
                className='basic-warranty-estimator-dealers'
                initialState={createHashMap(props.selectedDealers, 'account')}
                isRequired={true}
                label='DEALER_LOCATION'
                list={addCollectionLabels(props.selectedAccounts)}
                onChange={props.onDealerSelect}
                uid='account'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllDealers}
                type='button'
            >
                <FormattedMessage id={dealerSelectionMessage}/>
            </button>
        </section>
    );

};

BasicWarrantyEstimatorDealerCriteria.displayName = 'BasicWarrantyEstimatorDealerCriteria';
BasicWarrantyEstimatorDealerCriteria.propTypes = {
    onDealerSelect: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default BasicWarrantyEstimatorDealerCriteria;




// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/components/basic-warranty-estimator-dealer-criteria.js